// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__216wU","filesListContainer":"PosDisputesFiles_filesListContainer__7jTxv","filesButton":"PosDisputesFiles_filesButton__33NPg"};